// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__eH0kN","question":"Question_question__GJ9f4","description":"Question_description__3be6N"};